module.exports = __webpack_public_path__ + "img/logo-cmic-sonora.95656421.png";